import { normalizeApiRoute } from '@tilly/shared';
export { normalizeApiRoute };
/** Background calls that are not something the user did. */
const NOISE = /^\/(auth|analytics|public\/analytics|devices)\b|\/(read|refresh|sync|unread-count)$/;
/**
 * Pure mapping from a finished API request to the event it should produce (or
 * none). Only the method, the normalized route, the status and the API's error
 * code are ever included: no bodies, query strings or record ids.
 */
export function classifyRequest(request, options = {}) {
    const { includeNetworkErrors = true, includeAdminActions = false } = options;
    const method = request.method.toUpperCase();
    const route = normalizeApiRoute(request.path);
    const code = request.code ?? '';
    const base = { method, route };
    if (request.status === null) {
        return includeNetworkErrors ? { name: 'api_error', data: { ...base, status: 0, code } } : null;
    }
    if (request.status >= 500) {
        return { name: 'api_error', data: { ...base, status: request.status, code } };
    }
    if (!includeAdminActions)
        return null;
    const isWrite = method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS';
    const isAdminRoute = route.startsWith('/admin/') || route.startsWith('/provider/');
    if (!isWrite || !isAdminRoute || NOISE.test(route))
        return null;
    // 401 is the token-refresh path, not an action the user failed at.
    if (request.status === 401)
        return null;
    if (request.status >= 200 && request.status < 300) {
        return { name: 'admin_action_completed', data: base };
    }
    return { name: 'admin_action_failed', data: { ...base, status: request.status, code } };
}
const ERROR_THROTTLE_MS = 30_000;
/**
 * Builds an `onRequestComplete` handler that classifies each request and hands
 * the resulting event to `report`. `api_error` is reported at most once per
 * method + route + status per 30 s, so a failing poll can't flood the backend.
 */
export function createRequestTelemetry(report, options = {}, now = Date.now) {
    const lastErrorAt = new Map();
    return (request) => {
        const event = classifyRequest(request, options);
        if (!event)
            return;
        if (event.name === 'api_error') {
            const key = `${event.data.method} ${event.data.route} ${event.data.status}`;
            const last = lastErrorAt.get(key);
            if (last !== undefined && now() - last < ERROR_THROTTLE_MS)
                return;
            lastErrorAt.set(key, now());
        }
        report(event);
    };
}
//# sourceMappingURL=telemetry.js.map